import { render, staticRenderFns } from "./species-list-view.vue?vue&type=template&id=246bbd29&scoped=true&"
import script from "./species-list-view.vue?vue&type=script&lang=js&"
export * from "./species-list-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246bbd29",
  null
  
)

export default component.exports